<div class="topbar">
  <a class="topbar__logo" routerLink="/">
    <img class="topbar__logo-image" [src]="$logo()" alt="OneStop Pro" />
  </a>
  <ul class="topbar__list topbar__list--left">
    <li>
      <osp-whitelabeled-component
        [componentKey]="WhitelabeledComponentKey.CREATE_NEW_ENTITY_BUTTON"
        [defaultComponent]="CreateNewEntityButtonComponent"
      />
    </li>
  </ul>
  <ul class="topbar__list topbar__list--right">
    @if ($canSeeAutomatedTransfersNotificationsOverlay()) {
      <li>
        <osp-automated-transfers-notifications-center-overlay />
      </li>
    }

    @if ($canSeeAttention()) {
      <li>
        <osp-equipment-attention-overlay />
      </li>
    }
    @if ($canSeeNotifications()) {
      <li>
        <osp-notifications-center-overlay />
      </li>
    }
    <li>
      <osp-help-overlay />
    </li>

    <li>
      <osp-whitelabeled-component
        [componentKey]="WhitelabeledComponentKey.APP_SWITCHER"
        [defaultComponent]="ComponentPlaceholderComponent"
      />
    </li>

    <li>
      <osp-whitelabeled-component
        [componentKey]="WhitelabeledComponentKey.USER_SETTINGS_MENU"
        [defaultComponent]="UserSettingsMenuComponent"
      />
    </li>
  </ul>
</div>
